export default Object.freeze({
  ADD: 'add',
  EDIT: 'edit',
});
